import React from 'react';
import LifeCycleModal from '../LifeCycleModal';
import { lifeCycleEntitiesMap } from '../../constants/lifeCycle';
import SelectStage from '../SelectStage';
import { useChangeLifeCycleSuccess } from '../../utils/createChangeLifeCycleSuccessHandler';
import { useChangeRoomStage } from '../../../../../mutations/useChangeRoomStage';

const ChangeStageModal = ({ flatsGridKey, room }) => {
  const onSuccess = useChangeLifeCycleSuccess(flatsGridKey);

  const { mutateAsync, isLoading } = useChangeRoomStage({ onSuccess });

  const getOnSubmit = ({ closeModal }) => {
    return async (values) => {
      await mutateAsync(values);
      closeModal();
    };
  };

  return (
    <LifeCycleModal
      getInitialValue={getInitialValue}
      getOnSubmit={getOnSubmit}
      entity={lifeCycleEntitiesMap.stage}
      FormComponent={SelectStage}
      confirmLoading={isLoading}
      room={room}
      flatsGridKey={flatsGridKey}
    />
  );
};

export default ChangeStageModal;

function getInitialValue(room, lifeCycleState) {
  return typeof lifeCycleState === 'object'
    ? lifeCycleState?.stage?.id
    : room?.addressLifeCycle?.stageAddressLifeCycle?.id;
}
